var ExperimentType = /* @__PURE__ */ ((ExperimentType2) => {
  ExperimentType2[ExperimentType2["USER_RESEARCH"] = 0] = "USER_RESEARCH";
  ExperimentType2[ExperimentType2["USER_JOURNEY"] = 1] = "USER_JOURNEY";
  return ExperimentType2;
})(ExperimentType || {});
var ExperimentStatus = /* @__PURE__ */ ((ExperimentStatus2) => {
  ExperimentStatus2["ACTIVE"] = "active";
  ExperimentStatus2["INACTIVE"] = "inactive";
  ExperimentStatus2["LISTENING"] = "listening";
  return ExperimentStatus2;
})(ExperimentStatus || {});
export {
  ExperimentStatus,
  ExperimentType
};
